import React from 'react';
import { XMarkIcon, DocumentIcon, PhotoIcon } from '@heroicons/react/24/outline';

interface FileAttachmentProps {
  filename: string;
  fileSize: number;
  mimeType: string;
  onRemove?: () => void;
  previewUrl?: string;
}

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function FileAttachment({
  filename,
  fileSize,
  mimeType,
  onRemove,
  previewUrl,
}: FileAttachmentProps) {
  const isImage = mimeType.startsWith('image/');

  return (
    <div className="flex items-center gap-2 bg-surface-600 rounded-lg px-3 py-1.5 max-w-[220px]">
      {isImage && previewUrl ? (
        <img
          src={previewUrl}
          alt={filename}
          className="w-6 h-6 rounded object-cover flex-shrink-0"
        />
      ) : isImage ? (
        <PhotoIcon className="w-5 h-5 text-primary-400 flex-shrink-0" />
      ) : (
        <DocumentIcon className="w-5 h-5 text-primary-400 flex-shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-xs text-surface-200 truncate">{filename}</p>
        <p className="text-[10px] text-surface-400">{formatFileSize(fileSize)}</p>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="p-0.5 text-surface-400 hover:text-surface-200 transition-colors flex-shrink-0"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
